export default "__VITE_ASSET__BLv7sHSH__"